module.exports = __webpack_public_path__ + "media/images/take-photo-btn-1f3d4dc851860b97ffa7c38933bbe160.png";